import { atom } from "jotai";
import { focusAtom } from "jotai-optics";

export type AgendaQueryInputs = {
  duration?: number;
  times?: { timeGTE?: string; timeLTE?: string };
  groupSize?: number;
  courseBucketIds?: string[];
};

export const agendaQueryInputsAtom = atom<AgendaQueryInputs>({});

export const agendaQueryInputs_duration = focusAtom(
  agendaQueryInputsAtom,
  (o) => o.prop("duration")
);

export const agendaQueryInputs_times = focusAtom(agendaQueryInputsAtom, (o) =>
  o.prop("times")
);

export const agendaQueryInputs_groupSize = focusAtom(
  agendaQueryInputsAtom,
  (o) => o.prop("groupSize")
);

export const agendaQueryInputs_courseBucketIds = focusAtom(
  agendaQueryInputsAtom,
  (o) => o.prop("courseBucketIds")
);
